import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const GetDemoConfirmationContent = () => {
  return (
    <div className={styles.confirmation}>
      <div className={styles.confirmationIcon}>
        <Icon icon='check2' color='var(--green-60)' fontSize={32} />
      </div>
      <Typography
        className={styles.confirmationTitle}
        variant={'heading-lg'}
        ariaLabel={'GetDemoConfirmationTitle'}
      >
        Request received
      </Typography>
      <Typography
        variant={'body-rg-regular'}
        color={'var(--content-primary-secondary)'}
        ariaLabel={'GetDemoConfirmationDesc'}
      >
        Check your email for a scheduling link. Pick a time
        <br />
        and we&apos;ll handle the rest.
      </Typography>
    </div>
  )
}
